(() => {
  const updateDetails = (element, option) => {
    if (!option) return;
    element.querySelector('[data-gm-action-price]').textContent = option.dataset.price;
    const compare = element.querySelector('[data-gm-action-compare]');
    compare.textContent = option.dataset.compare || '';
    compare.hidden = !option.dataset.compare;
    const title = element.querySelector('[data-gm-action-variant]');
    if (title) title.textContent = option.dataset.title;
    const image = element.querySelector('.gm-action-image');
    if (image && option.dataset.image) { image.src = option.dataset.image; image.removeAttribute('srcset'); }
  };
  if (!customElements.get('gemonier-quick-purchase')) {
    customElements.define('gemonier-quick-purchase', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const form = this.querySelector('form');
        const drawer = this.closest('quick-buy-drawer');
        if (drawer) form.setAttribute('id', `gm-form-${drawer.id}`);
        const select = form.querySelector('[name="id"]');
        const button = form.querySelector('[type="submit"]');
        const error = this.querySelector('[data-gm-action-error]');
        const update = () => {
          const option = select.selectedOptions[0];
          updateDetails(this, option);
          button.disabled = option.dataset.available !== 'true';
          button.textContent = button.disabled ? 'Sold out' : 'Add to cart';
          const link = this.querySelector('[data-gm-action-link]');
          const url = new URL(link.href); url.searchParams.set('variant', select.value); link.href = url.href;
          error.hidden = true;
        };
        select.addEventListener('change', update, { signal: this.abort.signal });
        form.addEventListener('cart:error', event => { error.textContent = event.detail.error; error.hidden = false; }, { signal: this.abort.signal });
        update();
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  if (!customElements.get('gemonier-sticky-purchase')) {
    customElements.define('gemonier-sticky-purchase', class extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.mainButton = this.form?.querySelector('button[type="submit"]');
        if (!this.mainButton) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const button = this.querySelector('[data-gm-sticky-submit]');
        const label = this.querySelector('[data-gm-action-label]');
        const error = this.querySelector('[data-gm-action-error]');
        const sync = () => {
          const id = this.form.elements.namedItem('id')?.value;
          const option = [...this.querySelector('[data-gm-action-options]').options].find(option => option.value === id);
          updateDetails(this, option);
          const busy = this.mainButton.getAttribute('aria-busy') === 'true';
          button.disabled = this.mainButton.disabled || !option || option.dataset.available !== 'true';
          button.setAttribute('aria-busy', String(busy));
          label.textContent = busy ? 'Adding…' : !option || option.dataset.available !== 'true' ? 'Sold out' : 'Add to cart';
        };
        button.addEventListener('click', () => {
          error.hidden = true;
          // Keep validation and promotion handlers without the legacy timed redirect.
          this.form.requestSubmit(this.mainButton);
        }, { signal });
        this.form.addEventListener('variant:change', () => { sync(); error.hidden = true; }, { signal });
        this.form.addEventListener('change', sync, { signal });
        this.form.addEventListener('cart:error', event => { error.textContent = event.detail.error; error.hidden = false; }, { signal });
        this.buttonObserver = new MutationObserver(sync);
        this.buttonObserver.observe(this.mainButton, { attributes: true, attributeFilter: ['disabled', 'aria-busy'] });
        const visibility = () => {
          if (this.visibilityFrame) return;
          this.visibilityFrame = requestAnimationFrame(() => {
            this.visibilityFrame = 0;
            this.hidden = this.form.getBoundingClientRect().bottom >= 0;
          });
        };
        window.addEventListener('scroll', visibility, { passive: true, signal });
        window.addEventListener('resize', visibility, { passive: true, signal });
        visibility();
        sync();
      }
      disconnectedCallback() { this.abort?.abort(); this.buttonObserver?.disconnect(); cancelAnimationFrame(this.visibilityFrame); }
    });
  }
})();
